import { AssetTypeCode } from 'types/models/asset-type';
import SamplePoint, {
  LevelDisplayUnit,
  RawSamplePoint,
  VolumeDisplayUnit
} from 'types/models/samplePoint';
import getPhysicalPortNumberByLogicalPortNumber from 'utils/get-physical-port-number-by-logical-port-number';
import { RAW_TO_PARSED_ASSET_TYPE_CODE } from 'utils/SamplePoints/asset-types/parse-raw-asset-types';

// Ensure the 3 properties are always present in the config.
type DamConfig = SamplePoint['config'] & {
  levelDisplayUnit: LevelDisplayUnit;
  volumeDisplayUnit: VolumeDisplayUnit;
  liquidLevelMeasurementDirection: 'bottomUp' | 'topDown';
};

export const parseDamConfig = (damConfig: SamplePoint['config'], isUS: boolean): DamConfig => {
  const defaultLevelDisplayUnit = isUS ? LevelDisplayUnit.FT : LevelDisplayUnit.M;
  const defaultVolumeDisplayUnit = isUS ? VolumeDisplayUnit.CU_FT : VolumeDisplayUnit.ML;
  return {
    ...damConfig,
    levelDisplayUnit: damConfig.levelDisplayUnit ?? defaultLevelDisplayUnit,
    volumeDisplayUnit: damConfig.volumeDisplayUnit ?? defaultVolumeDisplayUnit,
    liquidLevelMeasurementDirection: damConfig.liquidLevelMeasurementDirection ?? 'bottomUp'
  };
};

/**
 * Takes a raw samplePoint, and returns a 'parsed' samplePoint supported by the
 * front-end, or null if it is of an unsupported asset type.
 */
const parseRawSamplePoint = (
  samplePoint: RawSamplePoint,
  country?: string
): SamplePoint | null => {
  const assetTypeId = RAW_TO_PARSED_ASSET_TYPE_CODE[samplePoint.assetTypeId];
  if (assetTypeId === undefined) {
    return null;
  }
  let parsedSamplePoint = {
    ...samplePoint,
    assetTypeId,
    deviceTags: {
      ...samplePoint.deviceTags,
      physicalPortNo: getPhysicalPortNumberByLogicalPortNumber(
        samplePoint.deviceTags.portNo
      )
    }
  };

  if (assetTypeId === AssetTypeCode.DAM) {
    parsedSamplePoint = {
      ...parsedSamplePoint,
      config: parseDamConfig(parsedSamplePoint.config, country === 'USA')
    };
  }

  return parsedSamplePoint;
};

export default parseRawSamplePoint;
